import React, { useMemo } from 'react'

import * as styles from './pagination.module.scss'
import { formatAmount } from '../../../utils/functions'

export const PaginationTotal = ({
   currentPage,
   itemsPerPage,
   pagesAvailable,
   totalCount,
}: PaginationTotalProps) => {
   const fromTo: PaginationTotals = useMemo(() => {
      return {
         from: (currentPage - 1) * itemsPerPage + 1,
         to:
            currentPage === pagesAvailable
               ? totalCount
               : currentPage * itemsPerPage,
      }
   }, [currentPage, itemsPerPage, totalCount, pagesAvailable])

   return (
      <div className={styles.paginationTotal}>
         {fromTo.from} - {itemsPerPage === 999999 ? totalCount : fromTo.to} of{' '}
         {formatAmount(totalCount, 'item')}
      </div>
   )
}
